<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
  },
  beforeCreate() {
    if (this.$session && !this.$session.exists()) {
      window.localStorage.setItem("authenticated", "false");
    }
  },
};
</script>

<style src="./styles/theme.scss" lang="scss" />
